import { FlagIcon } from "react-flag-kit";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getLevels } from "../../store/middleware/generic.middleware";
import { getPlan } from "../../store/middleware/student.middleware";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";
import { getLevelStudent, postLevelStudent, putLevelStudent } from "../../store/middleware/companyManager.middleware";

import { StudentManagementCss } from "./styles";

function LevelScoreAccount({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { levels } = useSelector((state) => state.genericReducer);

  const [languagesbylevel, setLanguagesbylevel] = useState([]);
  const [editingLevels, setEditingLevels] = useState({ indice: 0, edit: false });

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = async () => {
    dispatch(getLevels());

    await dispatch(getPlan(id))
      .then(async (res) => {
        let studentId = -1;
        let studentPlanLanguages = [];

        res?.map((plan) => {
          studentId = plan.student.id;
          plan.studentPlanLanguages.map((studentPlanLanguage) => {
            let indexLang = -1;
            studentPlanLanguages.map((lang, index) => {
              if (lang.lingoLanguageId === studentPlanLanguage.lingoLanguageId) indexLang = index;
            });
            if (indexLang === -1) {
              studentPlanLanguage.studentId = studentId;
              studentPlanLanguages.push(studentPlanLanguage);
            }
          });
        });

        await dispatch(getLevelStudent(id)).then((resp) => {
          resp.map((level) => {
            let indexLang = -1;

            studentPlanLanguages?.map((lang, index) => {
              if (lang.lingoLanguageId === level.lingoLanguageId) indexLang = index;
            });
            if (indexLang > -1) {
              if (!studentPlanLanguages[indexLang].levels) studentPlanLanguages[indexLang].levels = [];
              studentPlanLanguages[indexLang].levels.push(level);
            }
          });
          studentPlanLanguages.map((lang) => {
            if (!lang.levels) {
              let newlevel = {};
              newlevel.levelId = 1;
              newlevel.oralGrade = "";
              newlevel.writingGrade = "";
              newlevel.dictationGrade = "";
              newlevel.averageGrade = "";
              newlevel.editing = false;
              newlevel.isnew = true;
              newlevel.lingoLanguageId = lang.lingoLanguageId;
              newlevel.studentId = lang.studentId;
              lang.levels = [];
              lang.levels.push(newlevel);
            }
          });
          setLanguagesbylevel(studentPlanLanguages);
        });
      })
      .catch((err) => console.log("ERRO GET USERS ", err));
  };

  const addNewLevel = (e, index) => {
    let language = languagesbylevel;
    let selectedLang = { ...language[index] };

    let newlevel = { ...language[index] };
    newlevel.levelId = 1;
    newlevel.oralGrade = 0;
    newlevel.writingGrade = 0;
    newlevel.dictationGrade = 0;
    newlevel.averageGrade = 0;
    newlevel.editing = true;
    newlevel.isnew = true;
    selectedLang.levels.push(newlevel);

    setEditingLevels({ indice: index, edit: !editingLevels.edit });

    setLanguagesbylevel((state) => state.map((item, i) => (i === index ? { ...item, language } : item)));
  };

  const save = (e, index) => {
    let newLevels = [];
    let updateLevels = [];

    let haserror = false;
    languagesbylevel[index].levels.map((lvl) => {
      if (lvl.isnew && lvl.hasupdate) {
        newLevels.push({
          studentId: parseInt(lvl.studentId),
          lingoLanguageId: parseInt(lvl.lingoLanguageId),
          levelId: parseInt(lvl.levelId),
          oralGrade: parseFloat(lvl.oralGrade),
          writingGrade: parseFloat(lvl.writingGrade),
          dictationGrade: parseFloat(lvl.dictationGrade),
          averageGrade: parseFloat(lvl.averageGrade),
        });
      } else if (lvl.hasupdate) {
        updateLevels.push({
          id: parseInt(lvl.id),
          studentId: parseInt(lvl.studentId),
          lingoLanguageId: parseInt(lvl.lingoLanguageId),
          levelId: parseInt(lvl.levelId),
          oralGrade: parseFloat(lvl.oralGrade),
          writingGrade: parseFloat(lvl.writingGrade),
          dictationGrade: parseFloat(lvl.dictationGrade),
          averageGrade: parseFloat(lvl.averageGrade),
        });
      }
    });

    languagesbylevel[index].levels.map((level) => {
      let i = newLevels.findIndex((lv) => {
        return lv.levelId === level.levelId && languagesbylevel[index].levels.length > newLevels.length;
      });

      if (i === 0) console.log(haserror);
    });

    if (updateLevels.length === 0 && newLevels.length === 0) getData();

    if (newLevels.length > 0) {
      dispatch(postLevelStudent(newLevels))
        .then((res) => {
          if (!res || res.length === 0) return;
          if (updateLevels.length == 0) getData();
        })
        .catch((err) => console.log(err));
    }
    if (updateLevels.length > 0) {
      dispatch(putLevelStudent(updateLevels)).then(() => getData());
    }
  };

  const handleChangeList = async (e, languageIndex, lvlIndex) => {
    e.preventDefault();
    const { value, name } = e.target;

    if (value !== "") {
      setLanguagesbylevel((state) =>
        state.map((item, i) =>
          i === languageIndex
            ? {
                ...item,
                ["levels"]: item.levels.map((level, levelindex) =>
                  levelindex === lvlIndex ? { ...level, [name]: Number(value), ["hasupdate"]: true } : level,
                ),
              }
            : item,
        ),
      );
    }
  };

  const changeLevels = (e, index) => {
    e.preventDefault();
    setEditingLevels({ indice: index, edit: !editingLevels.edit });
  };

  return (
    <div className="view">
      <StudentManagementCss>
        {languagesbylevel?.length > 0 ? (
          languagesbylevel?.map((item, index) => (
            <div key={index} className="box">
              <div className="boxBig">
                {item?.levels.map((level, i) => (
                  <div key={i} className="itemBox">
                    <div className="levelTop">
                      <div className="levelTopLinguage">
                        {i === 0 && (
                          <div className="boxLanguage">
                            <h5>LINGO</h5>
                            <div className="language">
                              <FlagIcon size={35} code={item.lingoLanguage ? item.lingoLanguage.flag : ""} />
                              <h5>{item.lingoLanguage.description}</h5>
                            </div>
                          </div>
                        )}
                        {i >= 1 && (
                          <div className="boxLanguage">
                            <h5></h5>
                            <div className="language"></div>
                          </div>
                        )}
                        <div className="columLevel">
                          <div className="boxLevel">
                            <h5>{t("CARD_PLAN_LEVEL")}</h5>
                            {editingLevels.indice === index && editingLevels.edit ? (
                              <select
                                name="levelId"
                                value={level?.levelId}
                                onChange={(e) => handleChangeList(e, index, i)}
                              >
                                {levels?.map((lvl) => (
                                  <option key={lvl.id} value={lvl.id}>
                                    {lvl.level}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <h5>{level ? levels.find((item) => item.id === level?.levelId).level : ""}</h5>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grades">
                      {i < 1 && <h6>{t("GRADES")}</h6>}
                      {i >= 1 && <h6></h6>}
                      <div>
                        <h5>
                          <span>{t("ORAL")}</span>
                        </h5>
                        {editingLevels.indice === index && editingLevels.edit ? (
                          <input
                            min="0"
                            max="10"
                            type="number"
                            id={"oral" + i}
                            required={true}
                            name="oralGrade"
                            placeholder={t("ORAL")}
                            value={level?.oralGrade}
                            onChange={(e) => handleChangeList(e, index, i)}
                          />
                        ) : (
                          <h5>{level?.oralGrade !== "" ? level?.oralGrade : 0}</h5>
                        )}
                      </div>
                    </div>
                    <div>
                      <h5>
                        <span>{t("WRITING")}</span>
                      </h5>
                      {editingLevels.indice === index && editingLevels.edit ? (
                        <input
                          id={"writingGrade" + i}
                          type="number"
                          min="0"
                          max="10"
                          required={true}
                          placeholder={t("WRITING")}
                          name="writingGrade"
                          value={level?.writingGrade}
                          onChange={(e) => handleChangeList(e, index, i)}
                        />
                      ) : (
                        <h5>{level?.writingGrade !== "" ? level?.writingGrade : 0}</h5>
                      )}
                    </div>
                    <div>
                      <h5>
                        <span>{t("DICTATION")}</span>
                      </h5>
                      {editingLevels.indice === index && editingLevels.edit ? (
                        <input
                          id={"dictationGrade" + i}
                          type="number"
                          min="0"
                          max="10"
                          required={true}
                          placeholder={t("DICTATION")}
                          name="dictationGrade"
                          value={level?.dictationGrade}
                          onChange={(e) => handleChangeList(e, index, i)}
                        />
                      ) : (
                        <h5>{level?.dictationGrade !== "" ? level?.dictationGrade : 0}</h5>
                      )}
                    </div>
                    <div>
                      <h5>
                        <span>
                          <strong>{t("AVERAGE")}</strong>
                        </span>
                      </h5>
                      {editingLevels.indice === index && editingLevels.edit ? (
                        <input
                          id={"averageGrade" + i}
                          type="number"
                          min="0"
                          max="10"
                          required={true}
                          placeholder={t("AVERAGE")}
                          name="averageGrade"
                          value={level?.averageGrade}
                          onChange={(e) => handleChangeList(e, index, i)}
                        />
                      ) : (
                        <h5>{level?.averageGrade !== "" ? level?.averageGrade : 0}</h5>
                      )}
                    </div>
                    {user?.role != "b2b" && (
                      <div className="buttonLast">
                        {item.levels.length - 1 === i && (
                          <>
                            <button style={{ marginBottom: "10px" }} onClick={(e) => changeLevels(e, index)}>
                              Change
                            </button>
                            <button onClick={(e) => addNewLevel(e, index)}>Add New Level + </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ))}
                {editingLevels.indice === index && editingLevels.edit && (
                  <div className="buttons">
                    <button className="active" onClick={(e) => save(e, index)}>
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <PlaceholderText label="No Result" />
        )}
      </StudentManagementCss>
    </div>
  );
}

export default LevelScoreAccount;
